import { produce } from 'immer';

import { CLOSING_ACTION_TYPE } from '../actions';

const initialState = {
  closingInfo: null,
  closingDocuments: null,
  closingAmortizationSchedule: {},
  fundingInfo: null,
  postClosing: null,
  wireInstructionConfirmation: null,
};

const closingReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CLOSING_ACTION_TYPE.GET_CLOSING_INFO:
        draft.closingInfo = {
          ...payload.loanClosing,
          prepaidInterestCreditData: payload.prepaidInterestCreditData,
        };
        draft.fundingInfo = payload.loanFunding;
        draft.postClosing = payload.loanPostClosing;
        break;

      case CLOSING_ACTION_TYPE.EDIT_CLOSING_INFORMATION:
      case CLOSING_ACTION_TYPE.EDIT_CLOSING_COMPANY:
      case CLOSING_ACTION_TYPE.DELETE_CLOSING_COMPANY:
        draft.closingInfo = payload;
        break;

      case CLOSING_ACTION_TYPE.GET_CLOSING_AMORTIZATION_SCHEDULE:
        draft.closingAmortizationSchedule = payload;
        break;

      case CLOSING_ACTION_TYPE.GET_CLOSING_DOCUMENTS:
        draft.closingDocuments = payload;
        break;

      case CLOSING_ACTION_TYPE.GET_FUNDING_INFORMATION:
        draft.fundingInfo = payload;
        break;

      case CLOSING_ACTION_TYPE.EDIT_FUNDING_INFORMATION:
        draft.fundingInfo = payload.loanFunding;
        break;

      case CLOSING_ACTION_TYPE.GET_POST_CLOSING:
        draft.postClosing = payload;
        break;

      case CLOSING_ACTION_TYPE.EDIT_POST_CLOSING:
        draft.postClosing = payload.postClosing ?? payload;
        break;

      case CLOSING_ACTION_TYPE.GET_WIRE_INSTRUCTION_CONFIRMATION:
        draft.wireInstructionConfirmation = payload;
        break;

      default:
        return state;
    }
  });

export default closingReducer;
